import React from 'react';
import './MainCards.scss';
import { useNavigate } from 'react-router-dom';
import { BsPinFill, BsLightningChargeFill } from 'react-icons/bs';

interface Shortcut {
    title: string;
    url: string;
    icon: JSX.Element;
}

interface MainCardsProps {
  session: any | null;
}

const MainCards: React.FC<MainCardsProps> = ({session}) => {
    const navigate = useNavigate();

    const shortcuts: Shortcut[] = [
        {
            title: "Mesas",
            url: "/App/Restaurant",
            icon: <></>
        },
        {
            title: "Recibos",
            url: "/App/Receipts",
            icon: <></>
        },
        {
            title: "Menus",
            url: "/App/Menus",
            icon: <></>
        },
        {
            title: "Stock",
            url: "/App/Stock",
            icon: <></>
        }
    ];

    return (
        <div className="shortcuts-section">
            <div className="shortcuts-header">
                <BsLightningChargeFill className="shortcuts-icon" />
                <span className="shortcuts-label">Atajos:</span>
            </div>
            <div className="shortcuts-container">
                {shortcuts.map((shortcut, index) => (
                    <div 
                        key={index} 
                        className={`shortcut-card${!session ? ' disabled' : ''}`} 
                        onClick={() => session && navigate(shortcut.url)}
                    >
                        <div className="shortcut-pin">
                            <BsPinFill />
                        </div>
                        <div className="shortcut-content">
                            <span className="shortcut-title">{shortcut.title}</span>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default MainCards;
